module.exports = __webpack_public_path__ + "img/first_fw.76e604d5.png";